// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   COMMITMENT AUDIT TRAIL COMPONENT STYLES
   ============================================ */
/* Download button styling */
.button_style {
  margin-bottom: 1rem;
}

:host ::ng-deep .p-button {
  background: #27405f !important;
  border-color: #27405f !important;
  font-weight: 600 !important;
}

:host ::ng-deep .p-button:enabled:hover {
  background: #1d3049 !important;
  border-color: #1d3049 !important;
}

/* No record found message */
.noRecordFound {
  padding: 1rem;
  background: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 4px;
  color: #856404;
  margin: 1rem 0;
}

/* Error/unauthorized message */
.errorAuthId {
  padding: 1rem;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  color: #721c24;
  margin: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/app/commitment-audit-trail/commitment-audit-trail.component.scss"],"names":[],"mappings":"AAAA;;iDAAA;AAIA,4BAAA;AACA;EACC,mBAAA;AAAD;;AAGA;EACC,8BAAA;EACA,gCAAA;EACA,2BAAA;AAAD;;AAGA;EACC,8BAAA;EACA,gCAAA;AAAD;;AAGA,4BAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAAD;;AAGA,+BAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAAD","sourcesContent":["/* ============================================\n   COMMITMENT AUDIT TRAIL COMPONENT STYLES\n   ============================================ */\n\n/* Download button styling */\n.button_style {\n\tmargin-bottom: 1rem;\n}\n\n:host ::ng-deep .p-button {\n\tbackground: #27405f !important;\n\tborder-color: #27405f !important;\n\tfont-weight: 600 !important;\n}\n\n:host ::ng-deep .p-button:enabled:hover {\n\tbackground: #1d3049 !important;\n\tborder-color: #1d3049 !important;\n}\n\n/* No record found message */\n.noRecordFound {\n\tpadding: 1rem;\n\tbackground: #fff3cd;\n\tborder: 1px solid #ffeeba;\n\tborder-radius: 4px;\n\tcolor: #856404;\n\tmargin: 1rem 0;\n}\n\n/* Error/unauthorized message */\n.errorAuthId {\n\tpadding: 1rem;\n\tbackground: #f8d7da;\n\tborder: 1px solid #f5c6cb;\n\tborder-radius: 4px;\n\tcolor: #721c24;\n\tmargin: 1rem 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
